import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideCopyrightModal, setMeishiAmount } from "../../actions";

class CardAmountModal extends Component {

  state = {
    prices: [
      {amount: 20, price: 1320, unit: 66.0},
      {amount: 60, price: 2530, unit: 42.1},
      {amount: 100, price: 2970, unit: 29.7},
      {amount: 200, price: 4950, unit: 24.7},
    ],
    amount: 20,
    price: 1320
  }

  renderButton(amount, price, unit) {
    let classNames = ['card-price'];

    if (this.state.amount === amount) {
      classNames.push('alert-info')
    }

    return (
      <div key={amount} className={classNames.join(' ')} onClick={() => {
        this.setState({amount: amount, price: price});
        this.props.setMeishiAmount(amount);
      }}>
        <div className="card-price-amount text-right">{amount}枚</div>
        <div className="card-price-price text-right">
          {price}円 (税込) <small>{unit}円/枚</small>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="t-modal-backdrop">
        <div className="t-modal-box">
          <div className="t-modal-title">枚数を選択してください</div>
          <div className="t-modal-content">
            <div className="t-modal-flex">
              <div className="card-preview">
                {this.props.images.map((dataUrl, i) => {
                  return (
                    <img key={i} src={dataUrl} alt=""  />
                  )
                })}
              </div>
              <div className="card-price-table">
                {this.state.prices.map((p) => {
                  return this.renderButton(p.amount, p.price, p.unit);
                })}

                <div className="card-price card-price-static">
                  <div className="card-price-amount text-right">送料</div>
                  <div className="card-price-price text-right">無料</div>
                </div>

                <div className="card-price card-price-static">
                  <div className="card-price-amount text-right">合計金額</div>
                  <div className="card-price-price text-right">{this.state.price}円 (税込)</div>
                </div>
                {/*{this.renderButton(20, 760)}*/}
                {/*{this.renderButton(100, 6500)}*/}
                {/*{this.renderButton(200, 12000)}*/}
                {/*<div className="card-price">*/}
                {/*  <div className="card-price-amount text-right">20枚</div>*/}
                {/*  <div className="text-right">760円 (税込)</div>*/}
                {/*</div>*/}
                {/*<div className="card-price">*/}
                {/*  <div className="card-price-amount text-right">100枚</div>*/}
                {/*  <div className="text-right">6,500円 (税込)</div>*/}
                {/*</div>*/}
                {/*<div className="card-price">*/}
                {/*  <div className="card-price-amount text-right">200枚</div>*/}
                {/*  <div className="text-right">12,000円 (税込)</div>*/}
                {/*</div>*/}
              </div>

            </div>

          </div>
          <div className="t-modal-footer">
            <div className="t-modal-footer-note">
              他者の権利に関わる問題は発注者の責任でお願い致します。<br />
              当社は他者の権利の侵害がない前提でお引き受けいたします。
            </div>
            <div className="t-modal-buttons">
              <button className="btn btn-success" onClick={this.props.onCheckout}>
                注文する
              </button>
              &nbsp;
              <button className="btn btn-default" onClick={this.props.hideCopyrightModal}>キャンセル</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(f => f, {hideCopyrightModal, setMeishiAmount})(CardAmountModal);


// WEBPACK FOOTER //
// ./src/components/Face/CardAmountModal.js